import { Navbar } from "@/components/marketing/Navbar";
import { Hero } from "@/components/marketing/Hero";
import { ThreatMarquee } from "@/components/marketing/ThreatMarquee";
import { SavingsCalculator } from "@/components/marketing/SavingsCalculator";
import { Features } from "@/components/marketing/Features";
import { HowItWorks } from "@/components/marketing/HowItWorks";
import { Comparison } from "@/components/marketing/Comparison";
import { Leaderboard } from "@/components/marketing/Leaderboard";
import { Pricing } from "@/components/marketing/Pricing";
import { FAQSection } from "@/components/marketing/FAQSection";
import { CTASection, Footer } from "@/components/marketing/Footer";

export default function Landing() {
  return (
    <div className="bg-[#040914] min-h-screen">
      <Navbar />
      <Hero />
      <ThreatMarquee />
      <SavingsCalculator />
      <Features />
      <HowItWorks />
      <Comparison />
      <Leaderboard />
      <Pricing />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
